/** Samsung Internet blanks the page under a fixed element that uses backdrop-filter. */
export function isSamsungInternet(userAgent) {
  const ua = userAgent ?? (typeof navigator !== 'undefined' ? navigator.userAgent : '');
  return /SamsungBrowser/i.test(ua || '');
}
